// Styling
import style from "./bg-color.module.scss";

export default function BackgroundColor({ colorSettings }) {
  // Define Variables
  let color = "";
  let themecolor = "";

  // Color Types
  switch (colorSettings.type) {
    case "custom":
      color = {
        backgroundColor: colorSettings.picker,
        position: "absolute",
        inset: 0,
      };
      break;
    case "theme":
      themecolor = colorSettings.select[0];
      break;
    case "gradient":
      const gradientDir = colorSettings.gradientDirection ?? 0;
      let gradientColor = "linear-gradient(" + gradientDir + "deg, ";

      colorSettings.gradientColors.map((gradient) => {
        gradientColor += gradient.color;
        gradientColor += gradient.stop ? " " + gradient.stop + "%," : ", ";
      });
      gradientColor = gradientColor.replace(/,$/, "");
      gradientColor += ")";

      color = {
        backgroundImage: gradientColor,
        position: "absolute",
        inset: 0,
      };
      break;
    default:
      break;
  }

  //   var props = {
  //     value: "foo",
  //     ...(condition && { disabled: true }),
  //   };

  //   var component = <div {...props} />;

  return (
    <div
      className={`bgColor ${style.bgColor}`}
      {...(color ? { style: color } : {})}
      //{...(themecolor ? { "data-theme-color": themecolor } : {})}
      //   data-theme={condition ? themecolor : null}

      {...(themecolor && { "data-theme-color": themecolor })}
      //   {...(this.props.isTrue && { style: { color: "red" } })}
    ></div>
  );
}
